import { render, staticRenderFns } from "./TgMobileGameDetail.vue?vue&type=template&id=173686c8&"
import script from "./TgMobileGameDetail.vue?vue&type=script&lang=js&"
export * from "./TgMobileGameDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports